import React from "react";
import { clearToken } from "../redux/RTK/authSlice";
import { useDispatch } from "react-redux";
function Menu({ isOpen, onMenuClick }) {
  const menuClassName = `${isOpen ? "show" : ""}`;
  let env = process.env.REACT_APP_ENV;
  let dispatch = useDispatch();
const getClients = (e) => {
      let redirectUrl =
      env === "dev" || env === "qa"
        ? `https://${env}.hibbertordering.com/selectClient`
        : `https://hibbertordering.com/selectClient`;
        
    window.location.href = redirectUrl;
}

const logmeOut = (e) => {   
      let redirectUrl =
      env === "dev" || env === "qa"
        ? `https://${env}.hibbertordering.com/logoutMcoeUser`
        : `https://hibbertordering.com/logoutMcoeUser`;

    //dispatch(clearToken());
    window.location.href = redirectUrl;
     
}

  return (
    <nav
      id="cms-lateral-nav"
      style={isOpen ? {visibility : "visible", transform:'translateX(0px)', overflowX: "hidden"}:{}}
    >
      <div className="span12 margin-bottom">
        <ul className="okta-mobile text-center">
          <li>
            <a className="okta" href="https://hibbert.okta.com/">
              <img src="img/Hibbert_okta.svg" alt="Logo" />
            </a>
          </li>
          <li>
            <div
              style={{ display: "inline-block" }}
              className="cms-cart-container empty"
            >
              <a href="#0" className="cms-cart-trigger2">
                {" "}
                Cart
                <ul className="count" style={{ display: "block" }}>
                  <li>0</li>
                  <li>0</li>
                </ul>
              </a>
            </div>
          </li>
        </ul>
      </div>
      <hr />
      <div className="span12 slideout-menu">
         <button
          type="button"
          id="cms-menu-trigger"
          className="cms-menu-trigger is-clicked"
          onClick={onMenuClick}
        >
          <span className="cms-menu-icon"></span>
        </button>
        <ul className="cms-navigation">
          {/* <li>
            <a href="#text-styles">Approve Hold Orders</a>
          </li> */}
          <li>
            <a href="#" onClick={getClients}>Client Selection</a>
          </li>
          {/* <li>
            <a href="#modals">Order History</a>
          </li> */}
          {/* <li>
            <a href="#">Order on Behalf of</a>
          </li> */}
          {/* <li>
            <a href="#">View Lists</a>
          </li> */}
          <li>
            <a href="#" onClick={logmeOut}>Logout</a>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Menu;
